export enum PaymentTypeEnum {
  WEB_PAYMENT = 'WEB_PAYMENT',
  ORDER_PAYMENT = 'ORDER_PAYMENT',
  PAYMENT = 'PAYMENT',
}